import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { AgentsModule } from '@agents/agents.module';
import { AuthRoutingModule } from '@auth/auth-routing.module';
import { RegistrationFormComponent } from '@auth/components/registration-form/registration-form.component';
import { locale as english } from '@auth/i18n/en';
import { ForgotPasswordComponent } from '@auth/pages/forgot-password/forgot-password.component';
import { LoginComponent } from '@auth/pages/login/login.component';
import { RegistrationComponent } from '@auth/pages/registration/registration.component';
import { RestorePasswordComponent } from '@auth/pages/restore-password/restore-password.component';
import { serverMessagesMapping } from '@auth/server-message-mapping/server-message-mapping';
import { AuthEffects } from '@auth/store/effects/auth.effects';
import { RestorePasswordEffects } from '@auth/store/effects/restore-password.effects';
import { authReducer } from '@auth/store/reducers/auth.reducer';
import { RpcControlsModule } from '@core-controls/controls.module';
import { RpcDirectivesModule } from '@core-directives/directives.module';
import { ScrollToTopModule } from '@core-layout/scroll-to-top/scroll-to-top.module';
import { ServerMessageService } from '@core-services/server-message.service';
import { TranslationLoaderService } from '@core-services/translation-loader.service';

import { UsersModule } from '@users/users.module';
import { SwitchCollaborationSpaceEffects } from './store/effects/switch-collaboration-space.effects';
import { AdditionalFooterModule } from '@core-layout/additional-footer/additional-footer.module';
import { NotAuthorizedToolbarModule } from '@core-layout/not-authorized-toolbar/not-authorized-toolbar.module';
import { LogoModule } from '@core-layout/logo/logo.module';

@NgModule({
    imports: [
    // Library Modules
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    // Application Modules
    RpcDirectivesModule,
    AgentsModule,
    UsersModule,
    RpcControlsModule,
    ScrollToTopModule,
    AdditionalFooterModule,
    NotAuthorizedToolbarModule,
    LogoModule,
    // Module Configuration
    AuthRoutingModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects, RestorePasswordEffects, SwitchCollaborationSpaceEffects]),
    LoginComponent,
    RegistrationComponent,
    RegistrationFormComponent,
    RestorePasswordComponent,
    ForgotPasswordComponent
],
    exports: []
})
export class AuthModule {
    constructor(
        private readonly translationLoaderService: TranslationLoaderService,
        private readonly serverMessageService: ServerMessageService
    ) {
        this.translationLoaderService.loadTranslations(english);
        this.serverMessageService.loadServerMessagesMapping(serverMessagesMapping);
    }
}